import { useState , useEffect } from 'react'

import GenericGrid from '../../../components/grid/grid'
import { renderColumns } from '../../../utils/helper'

// data

const GridData = [ 
    {
        id:1,
        name:"General"
    },
    {
        id:2,
        name:"Toc"
    },
    {
        id:3,
        name:"Rules"
    },
    {
        id:4,
        name:"System Message"
    },
    {
        id:5,
        name:"Rule Based On Feedback"
    },
]   

const localKey = "prompts_sel_row"

const LeftContent = ( { selectedGridRow , setSelectedGridRow } ) => {
     const [dataState, setDataState] = useState({
      skip: 0,
      take: 100,
      sort: [],
      filter: null
    });
    const [ data , setData ] = useState( [] )

    const columns = [
        {
            title:"Prompts Type",
            field:"name"
        }
    ]

    const handleDataStateChange = (e) => {
       setDataState(e.dataState);
    };  


 const handleSelectionChange = (event) => {
  const newData = data.map(item => ({
    ...item,
    selected: item.id === event.dataItem.id
  }));

  const selectedItem = newData.find( item => item.selected )

  setData(newData);

  localStorage.setItem( localKey , JSON.stringify( selectedItem ? selectedItem : {} ) )

};

    useEffect(()=>{
      setData( GridData )
    },[])  

    
    // get the selected row 
    useEffect(()=>{
      const selRow = JSON.parse( localStorage.getItem( localKey ) )
      if( selRow ) setSelectedGridRow( selRow )
    },[data])

  return (
    <>
             <GenericGrid
               data={data}
               columns={renderColumns(columns)}
               dataState={dataState}
               onDataStateChange={handleDataStateChange}
               pageable={false}
               sortable={false}
               filterable={false}
               style={{ height:"auto" , width:"100%"  }}
               dataItemKey = { "id" }
              selectable={{
                        enabled: true,
                        mode: "single",
                        drag: false,
                        cell: false}}
               onSelectionChange={handleSelectionChange}
               selectedRow = {null}
               storageField = {localKey}
               />
    </>
  )
}

export default LeftContent